/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Dialog,
  DialogContent,
  DialogProps,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import Badge from "components/UI/Badge/Badge";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import React from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useFileSubmittedForBulkUpload } from "services/input-core/external-data/get-file-submitted";

interface Props extends DialogProps {
  processId: string;
}

const ViewSensitiveDataModal: React.FC<Props> = ({ processId, ...props }) => {
  const { t } = useTranslation("bulk-upload");

  const { data: sensitiveData } = useFileSubmittedForBulkUpload(processId);

  const isTypeValid = (type: string) => {
    return type === "NIE" || type === "DNI" || type === "Pasaporte";
  };

  const drawTableAlertErrorsValidation = (listResult: any) => {
    const result: any = [];

    if (
      listResult.filter(
        (x: any) => x.status !== undefined && x.message !== undefined,
      ).length === 0
    )
      return listResult;

    listResult.forEach((item: any) => {
      const validators = item.validators?.items.map((v: any) => (
        <>
          <div>
            <label
              style={{
                fontSize: "14px",
                color: "white",
                textTransform: "none",
              }}
            >
              {isTypeValid(item.documentType)
                ? t(`${v.field}.${v.ok.toString()}`)
                : t("invalid-type")}
            </label>
          </div>
        </>
      ));

      function getStatus(status: any) {
        switch (status) {
          case "yes":
            return (
              <div className="actions-right">
                <Badge key={0} color="success">
                  Ok
                </Badge>
              </div>
            );
          case "no":
            return (
              <div className="actions-right">
                <Badge color="danger">
                  <span>{validators ?? t("unmapped-error")}</span>
                </Badge>
              </div>
            );
          case "pending":
            return (
              <div className="actions-right">
                <Badge color="info">
                  <Tooltip title={validators ? validators : ""}>
                    <span>Warning</span>
                  </Tooltip>
                </Badge>
              </div>
            );
        }
      }

      const worker = {
        workerID: item.workerID,
        documentType: item.documentType,
        documentNumber: item.documentNumber,
        documentSecurityNumber: item.documentSecurityNumber,
        status: getStatus(item.status),
      };

      result.push(worker);
    });

    return result;
  };

  return (
    <Dialog {...props} fullWidth maxWidth="lg">
      <DialogTitle>{t("view-data.title")}</DialogTitle>

      <DialogContent style={{ padding: "30px" }}>
        {sensitiveData?.uploadedData?.length <
          sensitiveData?.qttyRecordsUploaded && (
          <Alert variant="warning">
            {`${
              sensitiveData?.qttyRecordsUploaded -
              sensitiveData?.uploadedData?.length
            } ${t("view-data.alert")}`}
          </Alert>
        )}
        <h4 style={{ marginTop: "30px", fontWeight: "bold", opacity: 0.6 }}>
          {t("view-data.table-title")}
        </h4>
        <ReactTable
          initialPageSize={5}
          columns={[
            {
              Header: t("view-data.header.workerId"),
              accessor: "workerID",
            },
            {
              Header: t("view-data.header.documentType"),
              accessor: "documentType",
            },
            {
              Header: t("view-data.header.documentNumber"),
              accessor: "documentNumber",
            },
            {
              Header: t("view-data.header.documentSecurityNumber"),
              accessor: "documentSecurityNumber",
            },
            {
              Header: t("view-data.header.result"),
              accessor: "status",
            },
          ]}
          data={drawTableAlertErrorsValidation(
            sensitiveData?.uploadedData || [],
          )}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "48px",
          }}
        >
          <ButtonTS
            simple
            color="transparent"
            onClick={() => {
              props.onClose && props.onClose({}, "backdropClick");
            }}
          >
            {t("actions.close")}
          </ButtonTS>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewSensitiveDataModal;
